import React from 'react';
import { LTBox, LTButton, LTText } from '@lambdatestincprivate/lt-components';
import TestMuAIIcon from '../../assets/TestMuAIIcon';
import WarningIcon from '../../assets/WarningIcon';

const ERROR_TYPE = {
  ERROR: 'error',
  WARNING: 'warning',
};

const RCAErrorHandler = ({
  errorMessage = 'Root cause analysis could not be generated at the moment. Please retry.',
  errorTitle = 'RCA Generation Failed',
  onRetry,
  errorType = ERROR_TYPE.ERROR,
}) => {
  const isWarning = errorType === ERROR_TYPE.WARNING;
  return (
    <LTBox
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      padding="32px"
      border={!isWarning && '1px solid'}
      borderColor="border.default"
      margin="16px"
      borderRadius="6px"
    >
      <WarningIcon color={isWarning ? '#FBC930' : undefined} size={24} />
      <LTBox
        marginTop="8px"
        styles={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '4px',
          textAlign: 'center'
        }}
      >
        {errorTitle && (
          <LTText
            fontSize={LTText.FontSize.FONT_16}
            fontWeight="600"
            text={errorTitle}
            margin="0"
          />
        )}
        {errorMessage && (
          <LTText
            fontSize={LTText.FontSize.FONT_14}
            fontWeight="400"
            color="text.muted"
            text={errorMessage}
            margin="0"
            style={{ maxWidth: isWarning ? '400px' : 'none' }}
          />
        )}
      </LTBox>
      {!isWarning && (
        <LTButton
          leadingIcon={<TestMuAIIcon />}
          variant={LTButton.Variant.AI}
          size={LTButton.Size.MEDIUM}
          onClick={onRetry}
          style={{ marginTop: '32px' }}
        >
          Retry RCA
        </LTButton>
      )}
    </LTBox>
  );
};

RCAErrorHandler.Type = ERROR_TYPE;

export default RCAErrorHandler;
